// React.lazy con auto-reload one-shot quando il chunk fallisce.
//
// Bug classico post-deploy: il browser ha in cache index.html che riferisce un
// chunk con hash che, dopo la nuova build, NON esiste più sul server →
// `ChunkLoadError: Loading chunk N failed`. Il fix è ricaricare la pagina
// per scaricare il nuovo index.html, ma una sola volta (sessionStorage flag),
// così se il fail è reale (rete giù, deploy rotto) non entriamo in loop di
// reload.

import { lazy } from 'react';

const STORAGE_KEY = 'clab.chunkReloaded';

export function lazyWithRetry(componentImport) {
  return lazy(async () => {
    const alreadyReloaded = window.sessionStorage.getItem(STORAGE_KEY) === '1';
    try {
      const component = await componentImport();
      // Successo: pulisco il flag così un fail futuro può triggerare il reload
      window.sessionStorage.removeItem(STORAGE_KEY);
      return component;
    } catch (err) {
      const msg = String(err?.message || '');
      const isChunkError = /Loading chunk|Loading CSS chunk|ChunkLoadError/i.test(msg);
      if (isChunkError && !alreadyReloaded) {
        window.sessionStorage.setItem(STORAGE_KEY, '1');
        window.location.reload();
        // Non-rendering placeholder mentre la pagina si ricarica
        return { default: () => null };
      }
      throw err;
    }
  });
}
